export default __webpack_public_path__ + "static/media/left_bushes.acfc3a29.svg";